'use client';

import React from 'react';
import RackSlottingHeader from './components/RackSlottingHeader';
import RackSlottingBoard from './components/RackSlottingBoard';

export default function RackSlottingPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <RackSlottingHeader />
      <RackSlottingBoard />
    </div>
  );
}
